import { PageLocatorMap } from '../types/PageLocatorMap';

export const notFoundPage = {
  main: {
    h1: 'not-found-page.main.heading1',
    h2: 'not-found-page.main.heading2',
    returnHomeButton: 'not-found-page.main.return-home-button',
    root: 'not-found-page.main.root',
  },
} as const satisfies PageLocatorMap;
